import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    orders: [
        {
            id: 1,
            code: "MH 370",
            member_id: "012 345 6789",
            admin: "Nguyễn Văn A",
            username: ["Nguyễn Văn A", "Trần Thị B", "Lê Văn C"],
            product: "Tomato",
            goiBH: "Gói 1",
            fees: 7000000,
            status_id: 1,
            status_name: "Hoàn thành",
            status_color: "#069D27"
        },
        {
            id: 2,
            code: "GF 464",
            member_id: "012 345 6789",
            admin: "Nguyễn Thị B",
            username: ["Nguyễn Văn A"],
            product: "Tomato",
            goiBH: "Gói 1",
            fees: 9340000,
            status_id: 2,
            status_name: "Chờ kiểm duyệt",
            status_color: "#FFA21F"
        },
    ],
};

const productSlice = createSlice({
    name: "orders",
    initialState,
    reducers: {}
});

export default productSlice.reducer;
